<nav class="navbar is-link" aria-label="main navigation">
  <div class="navbar-brand">
    <a class="navbar-item" href="https://dilo.me">dilo. meet people going out</a
    >
  </div>
</nav>
